var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(-1177.75 -624.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 24,
    height: 24,
    transform: "translate(1177.75 624.25)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(1177.75 624.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M17.25,10V8c0-3.15-.89-5.25-5.25-5.25S6.75,4.85,6.75,8v2a.75.75,0,0,1-1.5,0V8c0-2.9.7-6.75,6.75-6.75S18.75,5.1,18.75,8v2a.75.75,0,0,1-1.5,0Z",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M8.75,16A3.25,3.25,0,1,1,12,19.25,3.256,3.256,0,0,1,8.75,16Zm1.5,0A1.75,1.75,0,1,0,12,14.25,1.758,1.758,0,0,0,10.25,16Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M7,22.75c-4.41,0-5.75-1.34-5.75-5.75V15c0-4.41,1.34-5.75,5.75-5.75H17c4.41,0,5.75,1.34,5.75,5.75v2c0,4.41-1.34,5.75-5.75,5.75ZM2.75,15v2c0,3.57.67,4.25,4.25,4.25H17c3.58,0,4.25-.68,4.25-4.25V15c0-3.57-.67-4.25-4.25-4.25H7C3.42,10.75,2.75,11.43,2.75,15Z",
    fill: "#15345a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockicon);
export default __webpack_public_path__ + "static/media/lockicon.c2d68948f07824ba38958f05af917c32.svg";
export { ForwardRef as ReactComponent };